import { jsxs, jsx } from "react/jsx-runtime";
import imgMemo from "../assets/print/img-memo.svg.js";
import imgQueda from "../assets/print/img-queda.svg.js";
function MemoPage({ pageWidth, pageHeight }) {
  const s = Math.min(pageWidth / 794, pageHeight / 1123);
  const cardW = 610 * s;
  const cardH = 949 * s;
  const cardLeft = (pageWidth - cardW) / 2;
  const cardTop = (pageHeight - cardH) / 2 - 7 * s;
  const linesLeft = cardLeft + 60 * s;
  const linesTop = cardTop + 159 * s;
  const linesW = 491 * s;
  const linesH = 700 * s;
  const lineCount = 20;
  const lineGap = linesH / lineCount;
  const memoLeft = cardLeft - 12 * s;
  const memoTop = cardTop + 42 * s;
  const quedaLeft = cardLeft + 346 * s;
  const quedaTop = cardTop + 735 * s;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "print-page",
      style: {
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
        width: pageWidth,
        height: pageHeight,
        background: "#DEF2DA"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              left: cardLeft,
              top: cardTop,
              width: cardW,
              height: cardH,
              background: "#ffffff",
              borderRadius: 40 * s
            }
          }
        ),
        Array.from({ length: lineCount }, (_, i) => /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              left: linesLeft,
              top: linesTop + i * lineGap,
              width: linesW,
              borderTop: "1px dotted #D1D5DB"
            }
          },
          i
        )),
        /* @__PURE__ */ jsx(
          "img",
          {
            src: imgMemo,
            alt: "이곳에 메모해보세요",
            style: {
              position: "absolute",
              left: memoLeft,
              top: memoTop,
              width: 267 * s,
              height: 72 * s
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "img",
          {
            src: imgQueda,
            alt: "queda",
            style: {
              position: "absolute",
              left: quedaLeft,
              top: quedaTop,
              width: 229 * s,
              height: 214 * s
            }
          }
        )
      ]
    }
  );
}
export {
  MemoPage
};
//# sourceMappingURL=MemoPage.js.map
